
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("l5vdF", function(module, exports) {
/* EmojiComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $ibzAc = parcelRequire("ibzAc");


var $etuMO = parcelRequire("etuMO");


var $1DWH0 = parcelRequire("1DWH0");


var $32x2E = parcelRequire("32x2E");

// This file is based off of the
// next/packages/emoji-title/src/EmojiComponent.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc170b51986f269a$var$EmojiSpan = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ju3g15vq _mt1t15vq _1pc71txs _5ile1txs",
            __cmplp.className
        ])
    });
});
const $cc170b51986f269a$var$SkeletonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1frub2c": (0, $7sObp.default)(__cmplp.size)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_p12f1ou6 _1e0c1o8l _4t3i1vpm _1bsb1vpm",
            __cmplp.className
        ])
    });
});
const $cc170b51986f269a$var$EmojiSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1frub2c": (0, $7sObp.default)(__cmplp.size)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7n82g _1wyb1vpm _1bsb1vpm _4t3i1vpm",
            __cmplp.className
        ])
    });
});
const $cc170b51986f269a$var$EMOJI_HEIGHT_MINI = 20;
const $cc170b51986f269a$export$9fc60f86d5a6479f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc170b51986f269a$var$SkeletonWrapper, {
        size: `${props.height || 20}px`,
        "data-testid": "emoji-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc170b51986f269a$var$EmojiSkeleton, {
        size: `${props.height || 20}px`
    }));
/**
 *
 * @param param
 *
 * In order to load media emojis we need a few parameters
 * Because Emojis within ADF provides: shortName, Id, text
 * (e.g)
 *     "shortName": ":slight_smile:",
 *     "id": "1f642",
 *     "text": "🙂"
 */ const $cc170b51986f269a$var$FetchedEmojiComponent = ({ id: id, shortName: shortName, cloudId: cloudId, userId: userId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc170b51986f269a$var$EmojiSpan, {
        "data-testid": "toc-emoji-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $etuMO.default), {
        emojiId: {
            id: id,
            shortName: shortName
        },
        emojiProvider: (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
            cloudId: cloudId,
            userId: userId
        }),
        fitToHeight: $cc170b51986f269a$var$EMOJI_HEIGHT_MINI,
        showTooltip: false
    }));
};
const $cc170b51986f269a$export$8d59648ac142d001 = (0, $1DWH0.default)()($cc170b51986f269a$var$FetchedEmojiComponent);
module.exports["EmojiPlaceholder"] = $cc170b51986f269a$export$9fc60f86d5a6479f;
module.exports["EmojiComponent"] = $cc170b51986f269a$export$8d59648ac142d001;

});


//# sourceMappingURL=EmojiComponent.e176e086.js.map
